import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	Interactive,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

const TimelineZoomRecording = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 30) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(495 / 30) * fps}
			style={{
				width: 2336,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/studio-close-ups/timeline-zoom-f00d9122be69.mp4"
				muted
				durationInFrames={(495 / 30) * fps}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(frame, [4, 8, 13], ['auto', 'custom', 'auto'], {
					easing: Easing.step1,
					extrapolateLeft: 'clamp',
					extrapolateRight: 'clamp',
				})}
				customCursor={
					'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize'
				}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 25, 29, 72, 77, 106, 109, 326, 348, 490, 493],
						[
							3.9910357595245056, 3.5919321835720552, 3.9910357595245056,
							3.5919321835720552, 3.9910357595245056, 3.5919321835720552,
							3.9910357595245056, 3.5919321835720552, 3.9910357595245056,
							3.5919321835720552, 3.9910357595245056,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							4, 5, 7, 8, 10, 11, 12, 13, 15, 16, 17, 19, 20, 21, 33, 34, 35,
							39, 40, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56,
							57, 58, 59, 60, 64, 65, 66, 80, 81, 82, 85, 86, 89, 90, 93, 94,
							95, 96, 97, 98, 99, 100, 101, 102, 112, 113, 114, 115, 116, 117,
							118, 119, 120, 126, 127, 129, 130, 132, 133, 134, 135, 137, 138,
							139, 140, 142, 143, 144, 146, 147, 148, 149, 150, 151, 153, 154,
							156, 157, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171,
							172, 173, 175, 176, 178, 179, 181, 182, 183, 185, 186, 187, 188,
							189, 190, 191, 192, 202, 203, 204, 206, 207, 208, 209, 212, 213,
							214, 215, 217, 218, 219, 220, 222, 223, 225, 226, 228, 229, 230,
							231, 232, 233, 234, 235, 237, 238, 239, 241, 242, 243, 244, 245,
							246, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272,
							273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285,
							288, 289, 290, 291, 292, 295, 296, 297, 298, 300, 301, 305, 306,
							308, 309, 313, 314, 316, 317, 319, 320, 321, 323, 324, 331, 332,
							333, 334, 335, 337, 338, 347, 348, 350, 351, 352, 353, 354, 355,
							357, 358, 359, 360, 362, 363, 364, 365, 366, 367, 369, 370, 371,
							372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 384, 385,
							386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398,
							399, 403, 404, 405, 406, 407, 408, 409, 410, 411, 425, 426, 427,
							428, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441,
							442, 444, 445, 446, 447, 448, 449, 450, 470, 471, 472, 473, 474,
							475, 476, 477, 478, 479, 480, 481, 482, 485, 486, 487, 488,
						],
						[
							'1027.1460586573128px 1329.420247490987px',
							'1045.0433596414305px 1209.4553249537173px',
							'1045.0433596414305px 1209.4553249537173px',
							'1160.5027769657995px 909.8626132709734px',
							'1160.5027769657995px 909.8626132709734px',
							'1167.8924291142941px 895.878398129202px',
							'1167.0038000584625px 891.34171294943px',
							'1167.0038000584625px 889.7515346389945px',
							'1167.0038000584625px 889.7515346389945px',
							'1174.0192926045017px 796.9287732631784px',
							'1175.6874208321153px 772.0315697164572px',
							'1175.6874208321153px 772.0315697164572px',
							'1180.161746078145px 701.6583844879665px',
							'1179.896716359739px 700.0837961609666px',
							'1179.896716359739px 700.0837961609666px',
							'1181.5336646204814px 747.7267855402904px',
							'1198.526746565332px 800.0779499171782px',
							'1198.526746565332px 800.0779499171782px',
							'1351.8230536880055px 1320.440417032057px',
							'1351.8230536880055px 1320.440417032057px',
							'1395.0228977881711px 1436.3675338594953px',
							'1437.8953522361883px 1434.4499658969112px',
							'1580.7619604404172px 1432.5947578680698px',
							'1676.4376887849558px 1438.7528013251485px',
							'1713.1988697262009px 1436.071324174218px',
							'1717.5952450550521px 1435.2918250024359px',
							'1728.679723277794px 1439.1893208613467px',
							'1792.3492156289585px 1485.5071616486407px',
							'1882.6308097047647px 1551.3436616973595px',
							'1909.44558121407px 1565.3902367728735px',
							'1916.5857936275943px 1568.4458735262594px',
							'1923.1335866705642px 1571.2832505115464px',
							'1940.5787781350482px 1582.4300886680307px',
							'1955.1865926142455px 1596.3207639091884px',
							'1959.957127545552px 1602.1046477638117px',
							'1960.175387313651px 1602.6970671343663px',
							'1960.2533372308292px 1602.7750170515444px',
							'1960.2533372308292px 1602.7750170515444px',
							'1946.2379421221865px 1591.7684887459807px',
							'1940.7034980025335px 1587.917762837377px',
							'1940.7034980025335px 1587.917762837377px',
							'1574.6818669005165px 1143.213485335672px',
							'1487.377959660918px 1004.5249926921953px',
							'1487.377959660918px 1004.5249926921953px',
							'1317.696579947384px 852.8032738965215px',
							'1317.696579947384px 852.8032738965215px',
							'1214.2882198187665px 773.4970281594076px',
							'1214.2882198187665px 773.4970281594076px',
							'1111.971158530644px 709.6248660235799px',
							'1108.9622917275651px 703.5603624671149px',
							'1108.5101822079314px 701.7363344051447px',
							'1108.9155217772582px 701.5804345707883px',
							'1120.3585696190198px 698.7118776186301px',
							'1131.910747344831px 696.6384098216896px',
							'1156.9794407093443px 694.2687323394719px',
							'1171.4157653707493px 693.9881126376304px',
							'1173.8789827535809px 693.9881126376304px',
							'1173.8789827535809px 693.9881126376304px',
							'1172.304394426581px 693.9881126376304px',
							'1170.7921660333236px 695.0326415278184px',
							'1168.76546818669px 696.0927604014421px',
							'1167.1752898762545px 696.9813894572737px',
							'1161.96823540875px 697.8544285296697px',
							'1149.932768196434px 701.1750950014616px',
							'1147.5163207639093px 701.50248465361px',
							'1147.391600896424px 701.50248465361px',
							'1147.391600896424px 701.50248465361px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1147.04862126084px 698.8365974861152px',
							'1146.4562018902855px 701.50248465361px',
							'1141.155607522167px 702.0481340738576px',
							'1111.191659358862px 705.602650297184px',
							'1096.1940952937737px 705.1817207444217px',
							'1096.1940952937737px 705.1817207444217px',
							'1011.7431550228978px 609.9581019195167px',
							'972.1445970963656px 537.1684692585014px',
							'958.035662087109px 505.2869531326123px',
							'958.035662087109px 505.2869531326123px',
							'951.6905388288026px 491.1156581896132px',
							'951.6905388288026px 491.1156581896132px',
							'951.0825294748124px 485.47208418591055px',
							'951.0825294748124px 485.47208418591055px',
							'951.2228393257333px 464.254116730001px',
							'951.2228393257333px 464.254116730001px',
							'958.1759719380299px 444.34570788268536px',
							'958.1759719380299px 444.34570788268536px',
							'982.4963460976323px 329.3695800448212px',
							'982.4963460976323px 329.3695800448212px',
							'982.9952255675729px 277.53288512130956px',
							'982.9952255675729px 277.5017051544383px',
							'982.9952255675729px 277.5017051544383px',
							'982.9952255675729px 277.1119555685472px',
							'982.9952255675729px 277.1119555685472px',
							'988.3737698528696px 277.1119555685472px',
							'994.8747929455325px 277.1119555685472px',
							'994.8747929455325px 277.1119555685472px',
							'1006.1307609860664px 276.98723570106205px',
							'1006.1307609860664px 276.98723570106205px',
							'1006.411380687908px 276.98723570106205px',
							'1006.411380687908px 276.98723570106205px',
							'1006.3646107376011px 277.37698528695313px',
							'1006.3646107376011px 277.37698528695313px',
							'1034.7383805904706px 489.08896034297965px',
							'1034.7383805904706px 489.08896034297965px',
							'1078.0941245249928px 708.4556172659067px',
							'1078.0941245249928px 708.4556172659067px',
							'1062.7068108740134px 727.0856474714996px',
							'1062.7068108740134px 727.0856474714996px',
							'1006.5516905388288px 718.4955665984605px',
							'1006.5516905388288px 718.4955665984605px',
							'995.7946019682354px 651.4118678748904px',
							'995.7946019682354px 651.4118678748904px',
							'993.1754847510475px 631.8308486797233px',
							'993.1754847510475px 631.8308486797233px',
							'989.8548182792556px 632.3141381662282px',
							'989.8548182792556px 632.3141381662282px',
							'988.0152002338498px 654.2492448601773px',
							'988.0152002338498px 654.2492448601773px',
							'997.3224203449284px 667.8281204326221px',
							'997.3224203449284px 667.8281204326221px',
							'995.3892623989087px 666.9083114099192px',
							'995.3892623989087px 666.9083114099192px',
							'995.3892623989087px 666.9083114099192px',
							'995.3892623989087px 666.9083114099192px',
							'995.3892623989087px 666.9083114099192px',
							'995.3892623989087px 666.9083114099192px',
							'995.3892623989087px 666.9083114099192px',
							'995.3892623989087px 666.9083114099192px',
							'995.3892623989087px 666.9083114099192px',
							'995.3892623989087px 666.9083114099192px',
							'1002.0617753093637px 671.8347461755822px',
							'1002.0617753093637px 671.8347461755822px',
							'999.3802981584332px 670.8993471694437px',
							'1005.2889018805417px 674.0173438565722px',
							'1005.2889018805417px 674.0173438565722px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1005.2889018805417px 674.2044236577999px',
							'1005.2889018805417px 674.2044236577999px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1003.3713339179577px 670.8993471694437px',
							'1005.2889018805417px 674.5629932768196px',
							'996.5273311897106px 698.6651076683231px',
							'999.8168176946313px 1092.826658871675px',
							'999.8168176946313px 1092.826658871675px',
							'995.373672415473px 1444.583455130079px',
							'995.373672415473px 1444.583455130079px',
							'991.9906460099386px 1450.1958491669102px',
							'991.9906460099386px 1450.1958491669102px',
							'991.9906460099386px 1450.772678554029px',
							'991.6632563577901px 1451.0844782227418px',
							'984.164474325246px 1512.197213290461px',
							'983.7123648056124px 1521.8941829874307px',
							'983.7123648056124px 1521.8941829874307px',
							'956.4766637435448px 1565.7332164084576px',
							'956.4766637435448px 1565.7332164084576px',
							'948.8219818766443px 1598.7528013251485px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

const TimelineZoomContent = () => {
	const {width, height} = useVideoConfig();

	return (
		<AbsoluteFill
			showInTimeline={false}
			style={{backgroundColor: '#151719', overflow: 'hidden'}}
		>
			<div
				style={{
					position: 'absolute',
					width: 2336,
					height: 1440,
					left: '50%',
					top: '50%',
					translate: '-50% -50%',
					rotate: '3deg',
					scale: 1.1 * Math.min(width / 2336, height / 1440),
				}}
			>
				<TimelineZoomRecording />
			</div>
		</AbsoluteFill>
	);
};

export const TimelineZoomComposition = Interactive.create({
	Component: TimelineZoomContent,
	layout: 'absolute-fill',
	schema: {},
});
